{
  "nl": {
    "document": {
      "actions": {
        "delete": "Verwijderen",
        "deleteMultipleDocuments": "Verwijderen",
        "delete_cancel": "Annuleren",
        "delete_documents": "Verwijder document | Verwijder documenten",
        "delete_documents_upload": "Verwijder {count} document | Verwijder {count} documenten",
        "download": "Downloaden",
        "edit": "Bewerken",
        "groupByCategory": "Schakelen tussen groeperen op categorie",
        "hideDetails": "Verberg details",
        "new": "Documenten",
        "new_customer": "Documenten toevoegen",
        "reset_filters": "Filters resetten",
        "share": "Deel",
        "shareCustomer": "Delen met klant",
        "shareCustomerPartners": "Delen met klant en projectpartners",
        "shareWithProjectPartners": "Delen (ongedaan maken) met projectpartners...",
        "share_documents": "Deel document | Deel documenten",
        "share_with": "Deel met...",
        "showDetails": "Toon details",
        "submit": "Opslaan",
        "tickBoxesDeletion": "Selecteer de documenten die je wil verwijderen.",
        "unshare": "Delen ongedaan maken",
        "unshare_documents": "Document delen ongedaan maken | Documenten delen ongedaan maken"
      },
      "attachable_types": {
        "building": "Gebouw",
        "decisions": "Beslissingen",
        "installment": "Betalingsschijf",
        "issue": "Punt",
        "lot": "Lot",
        "phase": "Fase",
        "project": "Project",
        "tickets": "Gesprekken",
        "unit": "Unit"
      },
      "attributes": {
        "category": "Categorie",
        "file_ext": "Bestandstype",
        "file_size": "Bestandsgrootte",
        "name": "Naam",
        "size": "Grootte",
        "type": "Type",
        "uploaded_at": "Geüpload om",
        "uploaded_by": "Geüpload door"
      },
      "category": {
        "admin": "Administratie",
        "aftercare": "Nazorg",
        "as_built": "Postinterventiedossier",
        "brochure": "Brochure",
        "conversation": "Gesprek",
        "decision": "Beslissing",
        "image": "Afbeelding",
        "invoice": "Factuur",
        "legal": "Wettelijk",
        "manual": "Handleiding",
        "other": "Overige",
        "plan": "Plan",
        "quote": "Offerte",
        "ticket": "Gesprek"
      },
      "labels": {
        "actions": "Acties",
        "allDocuments": "All documenten",
        "allUnits": "Alle Units",
        "backToCategories": "Categorieën",
        "building": "gebouw",
        "categories": "Categorieën",
        "category": "Categorie",
        "changeCategory": "Wijzig categorie in:",
        "changeFilterOrStartUploading": "Filter wijzigen of een nieuw document uploaden",
        "created": "Aangemaakt op",
        "customer": "Klant",
        "decision": "beslissing",
        "decisionsAndProposals": "Beslissingen en Voorstellen",
        "deleteOnlyOnLevel": "Dit document staat op {level_type}-niveau en kan enkel in de {level_type}-folder verwijderd worden.",
        "delete_documents": "Weet je zeker dat je dit document wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt. | Weet je zeker dat je deze documenten wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
        "disclaimerDocumentsCustomer": "Zoek of upload documenten met betrekking tot beslissing {decision_name}",
        "documents": "Documenten",
        "documents_all": "Alle documenten",
        "documents_all_projects": "Documenten alle projecten",
        "documents_plan": "Plandocumenten",
        "documents_plan_explainer": "Documenten die zijn toegevoegd aan de documentenmap van unit {unit_name} met de categorie 'Plan', worden automatisch toegevoegd aan deze beslissing en zijn toegankelijk voor alle partners.",
        "editDocument": "Wijzigen Document",
        "editDocumentName": "Documentnaam bewerken",
        "editDocumentNameSubtitle": "Voer een nieuwe naam in voor het document.",
        "fileTooLargeForPreview": "Bestand te groot om een voorbeeld te tonen. Probeer het te downloaden.",
        "files": "Bestanden {level_name}",
        "files_count": "Geen bestanden | 1 bestand | {count} bestanden",
        "filter": "Filteren",
        "folders": "Folders",
        "goToUnitDocumentsFolder": "Ga naar de {unit_name} documentenmap",
        "goToUnitsFolder": "Deze pagina bevat alleen beslissingsdocumenten. Ga naar de unit folder om de andere documenten te zien.",
        "include_original_documents": "Toon de te ondertekenen documenten",
        "includesProposalAndDocuments": "Bevat voorsteldocumenten en beslissingsdocumenten",
        "info": "Documenten met betrekking tot jouw woning zullen binnenkort hier beschikbaar zijn.",
        "lockedDocumentApprovedProposal": "Dit document hoort bij een goedgekeurd voorstel en kan niet worden verwijderd",
        "lockedDocumentDelete": "Dit document kan niet worden verwijderd",
        "lockedDocumentOtherLevel": "Dit document hoort bij {level} en kan alleen worden verwijderd bij de documenten van {level}",
        "lockedDocumentShareLevel": "Dit document hoort bij {level} en kan niet worden gedeeld met projectpartners",
        "lot": "lot",
        "more_info": "Meer info",
        "name_asc": "Naam A->Z",
        "name_desc": "Naam Z->A",
        "name_lower_asc": "Naam A->Z",
        "name_lower_desc": "Naam Z->A",
        "new": "Nieuw",
        "next": "Volgende",
        "noCustomer": "Nog geen klant toegewezen",
        "noPreviewPossible": "Geen voorbeeld mogelijk voor dit documenttype. Probeer het eerst te downloaden.",
        "noResults": "Geen resultaten",
        "no_plan_documents": "Geen plandocumenten toegevoegd aan de unitfolder",
        "onlyUnitDocumentsSharedWithProjectPartners": "Alleen unitdocument kunnen gedeeld worden met projectpartners",
        "original_documents": "Originele documenten",
        "original_documents_info": "Toon de originele, ongetekende versies van documenten die reeds ondertekend zijn of nog ondertekend moeten worden.",
        "owner": "Eigenaar",
        "page": "Bladzijde",
        "phase": "fase",
        "previous": "Vorige",
        "project": "project",
        "project_partners": "Projectpartners",
        "proposal": "voorstel",
        "searchName": "Zoeken op naam",
        "search_document": "Zoek document",
        "selected": "{count} document geselecteerd | {count} documenten geselecteerd",
        "shareWith": "Deel met",
        "sharedWithClient": "Gedeeld met {client_name}",
        "sharedWithProjectPartners": "Gedeeld met projectpartners",
        "shared_with": "Gedeeld met",
        "shared_with_partners": "Gedeeld met partners",
        "sharingSettingsDecision": "Binnen deze beslissing",
        "sharingSettingsProject": "In dit project",
        "showDocumentsFor": "Toon documenten voor",
        "showLevel": "Dit is een {level}document",
        "signature": "Handtekening",
        "signed": "Ondertekend op",
        "signedBy": "Ondertekend door",
        "source": "Oorsprong",
        "subtitleSharingDocuments": "Het geselecteerde document zal beschikbaar zijn voor projectpartners | De geselecteerde documenten zullen beschikbaar zijn voor projectpartners",
        "subtitleUnsharingDocuments": "Het geselecteerde document zal niet meer beschikbaar zijn voor projectpartners | De geselecteerde documenten zullen niet meer beschikbaar zijn voor projectpartners",
        "ticket": "conversatie",
        "unit": "unit",
        "unitFolder": "Ga naar unitdocumenten",
        "updated_at_asc": "Oudste eerst",
        "updated_at_desc": "Nieuwste eerst",
        "upload_failed": "1 of meer bestanden kunnen niet worden geüpload. Verwijder ze of probeer opnieuw te uploaden.",
        "uploadedBy": "Geüpload door",
        "visibleFor": "Gedeeld met",
        "warningNotShared": "Oeps! Niemand is geselecteerd. Weet je het zeker? Klik nogmaals om te bevestigen."
      },
      "placeholders": {
        "customers": {
          "none": {
            "subtitle": "Je zal een notificatie-email ontvangen wanneer een nieuw document beschikbaar is. Bekijk en download ze hier.",
            "title": "Nog geen documenten beschikbaar"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Het uploaden van documenten stuurt automatisch notificatie-emails naar relevante klanten.",
            "title": "Geen documenten voor {level_name}"
          }
        },
        "partners": {
          "navigate": {
            "subtitle": "Navigeer door de projectstructuur om de documenten van een unit te zien",
            "title": "Ga naar een unit om documenten te bekijken"
          },
          "new": {
            "subtitle": "Het uploaden van documenten stuurt automatisch notificatie-emails.",
            "title": "Nog geen documenten beschikbaar voor deze beslissing"
          },
          "none": {
            "subtitle": "Hier zal je documenten terugvinden voor {unit}",
            "title": "Nog geen documenten"
          }
        }
      },
      "toasts": {
        "bulk_delete": "Document succesvol verwijderd | Documenten succesvol verwijderd",
        "bulk_upload": "Document succesvol geüpload | Documenten succesvol geüpload",
        "update": "{count} document succesvol gewijzigd | {count} documenten succesvol gewijzigd",
        "upload_success": "{count} document werd succesvol geüpload | {count} document(en) werden succesvol geüpload"
      },
      "upload": {
        "activeUpload": "{count} bestand uploaden | {count} bestanden uploaden",
        "clear": "Wissen",
        "complete": "Upload compleet",
        "navigationWarning": {
          "continue": "Toch verlaten",
          "header": "Bezig met uploaden",
          "message": "Er worden momenteel bestanden geüpload. Als u deze pagina verlaat, wordt het uploaden geannuleerd en wordt er geen document aangemaakt."
        },
        "uploadFailed": "Uploaden mislukt"
      },
      "validation": {
        "need_category": "Categorie vereist",
        "need_category_all": "Alle documenten moeten een categorie hebben",
        "selectDocument": "Selecteer ten minste 1 document"
      }
    }
  }
}
